export default {
  primary: '#2D6535',
  secondary: '#FC6111',
  tertiary: '#8898AA',
  headerTitleColor: '#2D6535',
  backGroundColor: 'white',
  inactiveIconColor: '#C8D6E0',
  activeIconColor: '#FC6111',
};
